import { ApiError, apiCall } from '@/lib/api-client';
import type { CompanyUsage } from './types';

/** This month's company token usage. ``null`` means nothing to show — no
 * completed runs this period — which hides the pill; not an error. */
export async function fetchCompanyUsage(): Promise<CompanyUsage | null> {
  try {
    return await apiCall<CompanyUsage>('/api/usage');
  } catch (err) {
    if (err instanceof ApiError && err.status === 404) return null;
    throw err;
  }
}
